export const getDailyPercentageValue = (price: number | null | undefined, first: number | null | undefined): number => {
  const _price = price || 0;
  const _first = first || 0;

  if (!_first || !price) return 0;

  return Number(((Number(_price) - Number(_first)) / Number(_first)) * 100);
};
